module.exports = __webpack_public_path__ + "img/d53d318.svg";